module.exports = __webpack_public_path__ + "media/images/kaoawase/top/kaoawase-top-main-a5c55c3dc528f4439c64792b2440e24a.jpg";